var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrownOutline = function SvgCrownOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#18A87D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M17.343 4.898a.75.75 0 0 1 1.314 0l4.428 8.406a1.5 1.5 0 0 0 2.274.441l6.416-5.496a.75.75 0 0 1 1.197.779L28.72 24.397a1.5 1.5 0 0 1-1.434 1.1H8.715a1.5 1.5 0 0 1-1.435-1.1L3.03 9.029a.75.75 0 0 1 1.197-.778l6.414 5.496a1.5 1.5 0 0 0 2.274-.441zM7.5 31.5h21"
  })));
};
export default SvgCrownOutline;